<template>
  <NuxtPage />
  <CookieConsentBanner v-if="showCookieBanner" />
</template>

<script setup lang="ts">
const appConfig = useAppConfig()
const showCookieBanner = computed(() => !!(appConfig.site as any)?.showCookieBanner)
</script>
